import React, { useCallback, useState } from 'react';
import { Typography } from '@mui/material';
import { UploadInputWithoutArtifactID } from 'domain/shared/artifact/input';
import { Modal } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import type { UploadWbsFormProps } from './types';
import { useFormContext } from 'framework/form';

const UploadWbsModal = ({ closeModal }: UploadWbsFormProps) => {
  const { submitForm } = useFormContext();
  const [isModalOpen, setIsModalOpen] = useState(true);
  const closeForm = useCallback(() => {
    setIsModalOpen(false);
    closeModal();
  }, [setIsModalOpen, closeModal]);

  const confirmBtn = (
    <Button key="modal-confirm-button" onClick={submitForm}>
      Upload
    </Button>
  );

  return (
    <Modal
      key="modal-not-strict"
      modalSize="sm"
      backdrop="static"
      isOpen={isModalOpen}
      title="Are you sure?"
      onToggle={closeForm}
      buttons={[confirmBtn]}
    >
      <Typography
        sx={{
          mb: '20px',
        }}
      >
        Do you really want to upload WBS?
      </Typography>

      <UploadInputWithoutArtifactID
        required
        maxElements={1}
        label="WBS file"
        source="file"
        formats="xls,xlsx"
        canAddFromClipboard={false}
      />
    </Modal>
  );
};

export default UploadWbsModal;
